import React, { useEffect, useState } from "react";
import { Form, Row, Col, Space, Button, Spin } from "antd";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { InputFields } from "components/common";
import { dataFields } from "./Work.config";
import { employeeService } from "api";
import { dataFields as inputFieldsInit } from "./Work.config";

import Notification from "../../../../../../../components/common/notification/notification";
import { getLHDAPI } from "redux/reducer/employee";
import { tabKeys } from "types/enums";
import moment from "moment";
import { RangePickerProps } from "antd/es/date-picker";

const FormWork = (props) => {
  const { data, closeModal, type, getListApi, idEmp } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  //let idEmp = useAppSelector(state => state.employeesReducer.idEmp);
  const employeesStore = useAppSelector((state) => state.employeesReducer);
  const activeTabKey = useAppSelector((state) => state.common.activeTab);
  const { phongBanList, chucVuList, LHDList } = employeesStore;
  const dispatch = useAppDispatch();
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);

  useEffect(() => {
    getDetailsEmployee(idEmp);
    dispatch(
      getLHDAPI({
        page: 1,
        limit: 1000,
      })
    );
  }, [idEmp]);

  useEffect(() => {
    if (idEmp !== null) {
      if (type == "Thêm") {
        form.resetFields();
      } else {
        form.setFieldsValue(data);
      }
    }
  }, [data]);
  useEffect(() => {
    if (activeTabKey !== tabKeys.EMPLOYEE.LICENSE) {
      dataFields.forEach((field) => {
        if (field.name !== "hoTen") {
          form.resetFields([field.name]);
        }
      });
    }
  }, [activeTabKey]);
    useEffect(() => {
      const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
        const endDay = form.getFieldValue("den_ngay");
        if (endDay) {
          return currentDate > endDay;
        }
      };
      const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
        const start = form.getFieldValue("tu_ngay");
        if (start) {
          return currentDate < start;
        }
      };
      inputFieldsInit.find(e => e.name == "tu_ngay").disabledDate = disabledDateStart;
      inputFieldsInit.find(e => e.name == "den_ngay").disabledDate = disabledDateEnd;
      setFieldInfo([...inputFieldsInit]);
    }, []);
  const getDetailsEmployee = async (id) => {
    if (id) {
      setLoading(true);
      try {
        const res = await employeeService.getEmployee(id);
        form.setFieldValue("hoTen", res.hoTen);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
      }
    } else {
      Notification("error", "Chưa có thông tin nhân viên cho giấy phép");
    }
    setLoading(false);
  };

  useEffect(() => {
    setOptionsPhongBan(phongBanList);
    setOptionsChucVu(chucVuList);
    setOptionsLHD(LHDList);
  }, [phongBanList, chucVuList, LHDList]);

  const setOptionsPhongBan = (list) => {
    if (
      fieldInfo.find((field) => field.name === "id_phong_ban" && list?.length)
    ) {
      fieldInfo.find((field) => field.name === "id_phong_ban").options =
        list?.map((item) => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
      setFieldInfo([...fieldInfo]);
    }
  };

  const setOptionsChucVu = (list) => {
    if (
      fieldInfo.find((field) => field.name === "id_chuc_vu" && list?.length)
    ) {
      fieldInfo.find((field) => field.name === "id_chuc_vu").options =
        list?.map((item) => ({
          value: item.id,
          label: item.tenChucVu,
        }));
      setFieldInfo([...fieldInfo]);
    }
  };

  const setOptionsLHD = (list) => {
    if (
      fieldInfo.find(
        (field) => field.name === "id_loai_hop_dong" && list?.length
      )
    ) {
      fieldInfo.find((field) => field.name === "id_loai_hop_dong").options =
        list?.map((item) => ({
          value: item.id,
          label: item.tenLoai,
        }));
      setFieldInfo([...fieldInfo]);
    }
  };
  const addApi = async () => {
    setLoading(true);
    try {
      const value = form.getFieldsValue();
      const params = {
        ...value,
        id_nhan_vien: idEmp,
        tu_ngay: moment(new Date(value.tu_ngay)).format(
          "YYYY-MM-DDTHH:mm:ss.0000"
        ),
        den_ngay:
          value.den_ngay && value.den_ngay !== "Invalid date"
            ? moment(new Date(value.den_ngay)).format(
                "YYYY-MM-DDTHH:mm:ss.0000"
              )
            : null,
      };

      await employeeService.createWorkHistory(params);

      Notification("success", "Đã thêm giấy phép thành công");
      dataFields.forEach((field) => {
        if (field.name !== "hoTen") {
          form.resetFields([field.name]);
        }
      });
      setLoading(false);
      getListApi();
      closeModal();
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        error?.message || "Đã có lỗi khi thêm mới lịch sử công tác"
      );
    }
  };
  const onFinish = () => {
    addApi();
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical">
            <Row gutter={[16, 8]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy bỏ
                  </Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default FormWork;
